module.exports = __webpack_public_path__ + "img/cross_red.c4e80c07.svg";